
import { QInput } from 'quasar';
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'SInput',
  props: {
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    indent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  expose: ['validate', 'resetValidation'],
  setup(props, { slots, attrs }) {
    // console.log('props', props);
    // console.log('attrs', attrs);
    // console.log('attrs', attrs.dense, typeof attrs.dense === 'undefined');
    const classes = computed(() => {
      let result = 's-input ';
      result += `${props.required ? 's-input--required' : ''} `;
      result += `${attrs.readonly ? 's-input--readonly' : ''} `;
      result += `${attrs.disable ? 's-input--disable' : ''} `;
      result += `${typeof attrs.dense !== 'undefined' ? 's-input--dense' : ''} `;
      result += `${props.indent ? 's-input--indent' : ''} `;

      return result;
    });

    const refQInput = ref<QInput>(null as any);

    const validate = () => refQInput.value.validate();

    const resetValidation = () => refQInput.value.resetValidation();

    return { classes, slots, validate, refQInput, resetValidation };
  },
});
